<template>
  <v-app id="inspire" :style="{ background: $vuetify.theme.themes[theme].background }">
    <Snackbar />
    <Header v-if="!isLoginPage" :user-options="userOptions" />
    <v-main>
      <router-view v-if="!isLoading" />
    </v-main>
    <Footer v-if="!['LiveVideoCall'].includes($route.name) && !isLoginPage" />
  </v-app>
</template>

<script>
import Header from '@/components/menu/Header'
import Snackbar from '@/components/Snackbar'
import Footer from '@/components/Footer'
import { mapState } from 'vuex'
import getUserOptions from '@/utils/getUserOptions'

export default {
  components: {
    Header,
    Snackbar,
    Footer
  },
  props: {
    source: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    drawer: null,
    mode: null,
    userOptions: [],
    isLoading: false
  }),

  computed: {
    ...mapState({
      owners: state => state.owners
    }),
    isLoginPage() {
      return this.$route.name === 'Login'
    },
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light'
    }
  },

  async created() {
    this.setDarkMode()

    const { user } = this.$store.state
    const userId = user && user.preferred_username
    this.isLoading = true
    if (userId) {
      this.userOptions = await getUserOptions(userId)
      await this.$store.dispatch('usersConfig/getUsersModels', userId)
    }

    await this.$store.dispatch('usersConfig/getUsersMe')
    this.isLoading = false
  },

  methods: {
    setDarkMode() {
      const darkMode = JSON.parse(localStorage.getItem('darkMode'))

      if (darkMode === null) {
        localStorage.setItem('darkMode', false)
        this.$vuetify.theme.dark = false
        this.mode = false
      } else {
        this.$vuetify.theme.dark = darkMode
        this.mode = darkMode
      }
    }
  }
}
</script>
